import {sliderPhotosTpl} from '../../sliderPhotos/sliderPhotosTpl';
import {priceTooltipToggleTpl} from '../../priceToggle/priceToggleTpl';
import {getUriParams} from './discountFlag';

const cartoucheHousing = function (datas) {
  const item = datas.item;
  const currencySymbol = datas.currencySymbol || GLOBAL_SCRIPTS.CURRENCY_SYMBOL;
  const wordings = datas.wordings;
  const wordingIcones = datas.wordingIcones;
  const wordings_common = datas.wordingsCommon;
  const wordings_search = datas.wordingsSearch;
  const pageTemplate = datas.pageTemplate;
  const modifier = typeof datas.modifier !== 'undefined' ? datas.modifier : '';
  const domainCode = 'l2_' + datas.item.offer.code;
  const hasMulticottage = datas.hasMulticottage;
  const usps = item.offer.usp.slice(0, 3);
  let participantsSelected = typeof datas.resultListSelected.multiparticipants[0] != 'undefined' ? datas.resultListSelected.multiparticipants[0] : '';
  let participantsMulticottageSelected = typeof datas.resultListSelected.multiparticipants[1] != 'undefined' ? datas.resultListSelected.multiparticipants[1] : '';

  /* Add dispo=0 parameter if no availability for this cottage and if not already set in url */
  if (item.cache.stock <= 0 && item.housing.uri.indexOf('&dispo=0') === -1) {
    item.housing.uri += '&dispo=0';
  }

  let actionCodeName = typeof item.actionCode.name !== 'undefined' && item.actionCode.name !== null && item.actionCode.name.length ? item.actionCode.name.replace(/'/, '’').replace(/"/, ' ') : '';

  /*************************************************************************/
  /*** détermination de tous les éléments à concaténer dans le cartouche ***/
  /*************************************************************************/
  // BLOC IMAGE & ALERT //

  const housing = item.housing;
  const housingCode = housing.code;
  const comfortLevel = housing.comfortLevel !== null ? housing.comfortLevel : false;
  const comfortLevelName = comfortLevel ? comfortLevel.name : false;
  const housingType = housing.housingType !== null ? housing.housingType : false;
  const brandCode = item.brand.code !== null ? item.brand.code : '';
  const cache = item.cache;
  const itemSite = item.offer;
  const productCode = itemSite.code;
  const country = item.country;
  const region = item.region;
  const regionName = region.name.replace(/'/, '’');
  const destination = item.destination;
  const destinationName = destination.name.replace(/'/, '’');
  const siteName = itemSite.name.replace(/'/, '’');
  const photoList = item.photo;
  const htmlNew = housing.isNew ? '<span class="accCart-note">' + wordings['accommodation_new'] + '</span>' : '';
  // New label and Renovated label can't be displayed together. New label is the priority
  const htmlRenovated = !housing.isNew && housing.isRenovated ? '<span class="accCart-note"><i class="icon icon-renovated_park"></i>' + wordings['accommodation_renovated'] + '</span>' : '';
  const cartoucheType = typeof datas.cartoucheType !== 'undefined' ? datas.cartoucheType : 'regular';
  const cp_postfix = cartoucheType === 'counterproposal' ? '_CounterProp' : '';
  const sideBySide = cache.sideBySide !== 0 ? cache.sideBySide : false;
  const maxPets = cache.pets;
  const maxPersons = cache.maxPersons;
  const hasBasket = sessionStorage.getItem('basketDatas') !== null;
  const basketData = hasBasket ? JSON.parse(sessionStorage.getItem('basketDatas')) : null;
  const hasFirstCottage = basketData && basketData.cottagesSelected[0].isFilled;
  const cottageIndex = hasMulticottage && hasFirstCottage ? 1 : 0;
  const nbPets = typeof SEARCH_SCRIPTS.MULTIPARTICIPANTS[cottageIndex].PETS_SELECTED !== 'undefined' ? SEARCH_SCRIPTS.MULTIPARTICIPANTS[cottageIndex].PETS_SELECTED : 0;
  const isBookable = cache.stock > 0 || (cache.bookingUpgrade && Object.keys(cache.bookingUpgrade).length);
  const htmlNotesBlock = (housing.isNew || housing.isRenovated) ? `${htmlNew} ${htmlRenovated}` : '';
  const uriParams = getUriParams();

  let htmlStockAlert = '';

  //handle domain name for sck pages
  let htmlDomainTitle = '';
  let siteUri = itemSite.uri + uriParams;
  let geoUri = item.extra.uri_geo + uriParams;

  if (SEARCH_SCRIPTS.GROUP !== 'offer' && datas.controller !== 'product') {
    let productLabel = '';
    if (itemSite.isNew) {
      productLabel = `<span class="productLabel">${wordings.product_label_new}</span>`;
    } else if (itemSite.isRenovated) {
      productLabel = `<span class="productLabel">${wordings.product_label_renovated}</span>`;
    }

    htmlDomainTitle = `<div class="cartouche-title">
      <a href="${itemSite.url}"
          data-urlparams="${siteUri}"
          class="h3-like js-Tracking--link js-postParams"
          target="_blank"
          data-tracking='{"clickCode":"clickAccommodationCartouche","gaCategory":"${pageTemplate}","gaAction":"Cartouche title link","gaLabel":"${siteName}","gaValue":1, "accommodationCode":"${housingCode}"}'>
        <span class="titleDomain">${siteName}</span>
        ${productLabel}
      </a>
      <p class="cartouche-geo">
        <a href="${country.url}" data-urlparams="${geoUri}" title="${country.name}" class="cartouche-geoLink js-Tracking--link js-postParams" target="_blank" data-tracking='{"clickCode":"clickAccommodationBreadcrumb","gaCategory":"${pageTemplate}","gaAction":"Accommodation breadcrumb country","gaLabel":"${country.name}","gaValue":1}'>${country.name}</a>,
        <a href="${region.url}" data-urlparams="${geoUri}" title="${regionName}" class="cartouche-geoLink js-Tracking--link js-postParams" target="_blank" data-tracking='{"clickCode":"clickAccommodationBreadcrumb","gaCategory":"${pageTemplate}","gaAction":"Accommodation breadcrumb region","gaLabel":"${regionName}","gaValue":1}'>${regionName}</a>,
        <a href="${destination.url}" data-urlparams="${geoUri}" title="${destinationName}" class="cartouche-geoLink js-Tracking--link js-postParams" target="_blank" data-tracking='{"clickCode":"clickAccommodationBreadcrumb","gaCategory":"${pageTemplate}","gaAction":"Accommodation breadcrumb destination","gaLabel":"${destinationName}","gaValue":1}'>${destinationName}</a>
      </p>
    </div>`;
  }

  const housingComfortLevelName = comfortLevel && comfortLevel.name !== null ? comfortLevel.name : '',
    housingTypeName = housing.housingType ? housing.housingType.name : '',
    housingPmr = housing.isPmr ? wordings.accommodation_title_pmr : '',
    labelPmr = wordings[housing.isPmr ? 'accommodation_pmr' : housing.isPmrOption ? 'accommodation_Adaptedpmr' : 'accommodation_Notpmr'],
    labelPets = wordings[maxPets ? 'accommodation_petsAllowed' : 'accommodation_petsNotAllowed'],
    labelWifi = housing.wifiIncluded ? wordings['accommodation_wifi-Included'] : housing.wifiAvailable ? wordings.accommodation_wifiAvailable : wordings.accommodation_wifiNonAvailable;

  let housingProperty = '';
  if (GLOBAL_SCRIPTS.LANGUAGE_CODE_REAL === 'fr' || GLOBAL_SCRIPTS.MARKET_LANGUAGE === 'be-wl') {
    housingProperty = housingTypeName + ' ' + housingComfortLevelName + ' ' + housingPmr;
  } else if (GLOBAL_SCRIPTS.LANGUAGE_CODE_REAL === 'de') {
    housingProperty = (housingComfortLevelName !== '') ? housingComfortLevelName + '-' : '';
    housingProperty = housingProperty + housingTypeName + ' ' + housingPmr;
  } else if (GLOBAL_SCRIPTS.LANGUAGE_CODE_REAL === 'nl') {
    housingProperty = housingPmr + ' ' + housingComfortLevelName + ' ' + housingTypeName;
  } else {
    housingProperty = housingComfortLevelName + ' ' + housingTypeName + ' ' + housingPmr;
  }

  if (!housing.isNew && housing.isRenovated) {
    housingProperty += ' ' + wordings['accommodation_title_renovated'];
  }

  // BLOC CENTRAL (label + usp) //
  const housingUrlPopin = GLOBAL_SCRIPTS.BASELINK + '/light/popin/' + productCode + '/' + housingCode + housing.uri + (GLOBAL_SCRIPTS.CONTROLLER === 'product' || GLOBAL_SCRIPTS.CONTROLLER === 'singleclick' ? `&openedFrom=${GLOBAL_SCRIPTS.CONTROLLER}` : ''),
    capacityWording = DEVICE.isMobile ? wordings.accommodation_capacity_label : wordings.accommodation_capacity_label_housing,
    htmlCapacity = typeof capacityWording === 'string' ? capacityWording.replace('%XX', housing.capacity) : '',
    housingAdvantages = comfortLevel && !!comfortLevel.advantage ? comfortLevel.advantage.replace(/\n/g, '</li><li>') : housingType && !!housingType.advantage ? housingType.advantage.replace(/\n/g, '</li><li>') : '',
    htmlAdvantages = housingAdvantages !== '' ? `<ul><li>${housingAdvantages}</li></ul>` : '',
    htmlLinkInfos = `
      <a class="js-lightCottageDetails js-housingMoreInfo js-buttonLoader buttonContainer accCart-cottageButton js-Tracking--link"
        data-src="${housingUrlPopin}"
        title="${housingProperty} ${htmlCapacity} ${siteName}"
        data-tracking='{"popinName":"cottageDetails","actionCode":"clickAccommodationCartouche${cp_postfix}","gaCategory":"${pageTemplate}${cp_postfix}","gaAction":"Accommodation Info button${cp_postfix}","gaLabel":"Learn more","gaValue":1, "accommodationCode":"${housingCode}", "popinContainsFormsInfos":false}'
        data-aftershow="search:resultList:initAfterLightDetails"
        data-productcode="${productCode}"
        data-housingcode="${housingCode}"
        >
        <span class="button button--transparentBlack">
          ${wordings.cottage_detail_button_label}
        </span>
      </a>`;

  // ABTEST //
  const suffixPMR = !housing.isPmrOption && !housing.isPmr ? 'pmr-Not-Included' : 'pmr-Included',
    htmlBlocDetailsPMR = `<i class="icon icon-${suffixPMR}"><span class="genericTooltip">${labelPmr}</span></i>`,
    suffixPets = maxPets ? 'pets-Allowed' : 'pets-Not-Allowed',
    htmlBlocDetailsPets = `<i class="icon icon-${suffixPets}"><span class="genericTooltip">${labelPets}</span></i>`,
    suffixWifis = housing.wifiIncluded ? 'wifi-Included' : 'wifi-Not-Included',
    htmlBlocDetailsWifi = `<i class="icon icon-${suffixWifis}"><span class="genericTooltip">${labelWifi}</span></i>`,
    htmlBlocPMR = `<p class="accCart-advantages--title">${htmlBlocDetailsPMR}</p>`,
    htmlBlocPets = `<p class="accCart-advantages--title">${htmlBlocDetailsPets}</p>`,
    htmlBlocWifi = `<p class="accCart-advantages--title">${htmlBlocDetailsWifi}</p>`;

  // BLOC ICONES //
  const labelBedRoom = housing.nbBedroom > 1 ? wordingIcones['accommodation_bedroom1+'] : wordingIcones['accommodation_bedroom1'],
    htmlBedroom = `<span class="textIcon">${housing.nbBedroom} ${labelBedRoom}</span>`,
    strArea = housing.area;

  // BLOC PRICE  AND DURATION + discount //
  let price = '';
  let basePrice = '';
  let htmlPrice = '';
  let htmlDuration = '';
  let htmltooltipDuration = '';
  let htmlDates = '';

  const oPrice = cache.price !== null ? cache.price : false,
    promoPriceValue = oPrice ? parseInt(oPrice.promo.value, 10) : 0,
    originalPriceValue = oPrice ? parseInt(oPrice.original.value, 10) : 0;

  if (oPrice) {
    let strPrice = '';
    if (promoPriceValue > 0 && promoPriceValue < originalPriceValue) {
      price = promoPriceValue;
      basePrice = originalPriceValue;
      if (!GLOBAL_SCRIPTS.CURRENCY_IS_AFTER) {
        basePrice = `<del><span class="currency before">${currencySymbol}</span>${originalPriceValue}</del>`;
        strPrice = `<span class="currency">${currencySymbol}</span>${oPrice.promo.value}`;
      } else {
        basePrice = `<del>${originalPriceValue}<span class="currency">${currencySymbol}</span></del>`;
        strPrice = `${oPrice.promo.value}<span class="currency">${currencySymbol}</span>`;
      }
    } else {
      strPrice = `${oPrice.original.value}<span class="currency">${currencySymbol}</span>`;
    }
    htmlPrice = `${basePrice} <span class="accCart-price">${strPrice}</span>`;
  }

  const duration = cache.duration;
  if (duration > 1) {
    let wordingNight = duration === 1 ? wordings_common.night : wordings_common.nights;
    htmlDuration = `${(duration + 1)}&nbsp;${wordings_common.days} - ${duration}&nbsp;${wordingNight}`;
    htmltooltipDuration = ` (${duration}&nbsp;${wordingNight})`;
  }

  let dateStart = '',
    dateEnd = '';

  dateStart = new Date(cache.date);
  dateEnd =new Date(cache.dateEnd);
  htmlDates = datesFromTo(dateStart, dateEnd, GLOBAL_SCRIPTS.WORDINGS_COMMON.from_month, GLOBAL_SCRIPTS.WORDINGS_COMMON.to_month);

  /*** handling pets ***/
  const wordingsPet = nbPets > 1 ? 'participants_labelPets' : 'participants_labelpet',
    htmlPetsWithoutPrice = nbPets > 0 ? ' + ' + nbPets + ' ' + wordings_search[wordingsPet] : '',
    htmlPets = htmlPetsWithoutPrice,
    pricingWrd = datas.controller === 'singleclick' && SEARCH_SCRIPTS.DISPLAY_PRICE !== 'default' ? SEARCH_SCRIPTS.DISPLAY_PRICE : 'per_stay',
    htmlPricingLabel = `<p class="accCart-pricingLabel">${wordings[pricingWrd]}${htmlPets}</p>`;

  if (dateStart) {
    //handling dev / prod difference
    actionCodeName = actionCodeName === null ? '' : actionCodeName;
    //handling dates relation
    const diff = genericDate.diff(new Date(), new Date(dateStart)),
      wordingCode = diff > 60 ? 'early_booking_label' : 'last_minute_label';

    actionCodeName = actionCodeName && actionCodeName !== '' ? actionCodeName : wordings[wordingCode];
  }

  let htmlBlocPrice = '';
  let htmlBlocDates = '';

  const includedServices = [];
  if (typeof housing.servicesIncludedV2 !== 'undefined' && housing.servicesIncludedV2.length) {
    $.each(housing.servicesIncludedV2, function (i, service) {
      if (service.regroupement === 'PRICEINCLUDE') {
        includedServices.push(service.name.replace(/'/g, '’'));
      }
    });
  }

  if (datas.listNumber === 2) {
    participantsSelected = participantsMulticottageSelected;
  }

  const isParticipantObj = typeof participantsSelected === 'object';
  const htmlPopupPrice = priceTooltipToggleTpl({
    blockClass: 'accommodation-priceDetails',
    trackingGaAction: 'bloc accommodation',
    tooltipOptions: {
      includedServices: includedServices,
      typeTooltip: 'cottage',
      totalParticipants: datas.nbPersons,
      participants: {
        children: (isParticipantObj && typeof participantsSelected.baby !== 'undefined' ? participantsSelected.baby.code : 0) + (isParticipantObj && typeof participantsSelected.child !== 'undefined' ? participantsSelected.child.code : 0),
        senior: isParticipantObj && typeof participantsSelected.senior !== 'undefined' ? participantsSelected.senior.code : 0,
        adult: isParticipantObj && typeof participantsSelected.adult !== 'undefined' ? participantsSelected.adult.code : 0,
        pet: isParticipantObj && typeof participantsSelected.pet !== 'undefined' ? participantsSelected.pet.code : 0
      },
      taxTotal: oPrice.taxTotal,
      originalPrice: oPrice.original.value,
      originalPriceRaw: oPrice.original.raw,
      originalPriceRawBeforeTax: oPrice.original.rawBeforeTax,
      petsPrice: oPrice.pets.rawBeforeTax,
      differencePrice: oPrice.difference,
      differencePriceRaw: oPrice.rawDifference,
      discountLabel: actionCodeName,
      housingLabel: housingProperty.replace(/'|"/g, '’'),
      dateLabel: htmlDates + htmltooltipDuration,
      maxPersons: maxPersons,
      isLikeFancy: true,
      brandCode: brandCode,
      productCode: productCode
    }
  });

  const abcTestWording = datas.controller === 'singleclick' && SEARCH_SCRIPTS.DISPLAY_PRICE !== 'default' ? wordings[SEARCH_SCRIPTS.DISPLAY_PRICE] : wordings_common.nights;
  const abcTestDuration = `(${duration} ${abcTestWording})`;
  const abcTestSckDuration = `${wordings_common.price} ${abcTestWording}`;
  const abcWordingDuration = GLOBAL_SCRIPTS.ABCTEST_ACCOS_BLOCK !== 'A' && datas.controller !== 'singleclick' && SEARCH_SCRIPTS.DISPLAY_PRICE !== 'default' ? abcTestDuration : abcTestSckDuration;

  if (cache.stock > 0 && cache.stock < 6) {
    const wrdStressDispo_desktop_wording = cache.stock > 1 ? wordings_common.stocks_alert_plural : wordings_common.stocks_alert_singular,
      wrdStressDispo_desktop = typeof wrdStressDispo_desktop_wording === 'string' ? wrdStressDispo_desktop_wording.replace('%XX', cache.stock) : '',
      wrdStressDispo_mobile = wordings_common.stocks_alert_mobile.replace('%XX', cache.stock),
      wrdStressDispo = DEVICE.isMobile ? wrdStressDispo_mobile : wrdStressDispo_desktop;

    htmlStockAlert = `
      <div class="r-Grid-cell r-all--1of1 r-minM--1of2 r-minL--1of1 accCart-stockAlert u-iconAlert">
        <span>${wrdStressDispo}</span>
      </div>`;
  }

  if (((price !== '' || duration > 0) || htmlDuration !== '') && isBookable) {
    htmlBlocDates = `<div class="r-Grid-cell r-all--1of1 r-minM--1of2 r-minL--1of1 accCart-duration">
                      <p>${GLOBAL_SCRIPTS.ABCTEST_ACCOS_BLOCK !== 'A' && datas.controller !== 'singleclick' ? wordings_common.price : ''} ${htmlDates} ${DEVICE.isMobile ? abcWordingDuration : ''}</p>
                    </div>`;
    htmlBlocPrice = `<div class="accCart-priceContainer u-Font-promoFont">
                      <div>
                        ${GLOBAL_SCRIPTS.ABCTEST_ACCOS_BLOCK !== 'A' ? htmlStockAlert : ''}
                      </div>
                      <div>
                        ${htmlPrice}
                        ${htmlPopupPrice}
                      </div>
                    </div>
                    ${htmlPricingLabel}`;
  }

  let htmlBookButton = '';
  const classIPLABEL = datas.controller === 'product' ? ' IPLABEL_accomsBookingButton' : '';
  const dataAttributes = {
    domainCode: domainCode,
    domainname: 'domainName',
    includedServices: includedServices,
    levelconfort: 'levelConfort',
    maxcapacity: typeof cache.upgradeMaxPersons !== 'undefined' ? cache.upgradeMaxPersons : housing.capacity,
    maxbabies: typeof cache.upgradeMaxBabies !== 'undefined' ? cache.upgradeMaxBabies : cache.maxBabies,
    maxchildren: typeof cache.upgradeMaxChildren !== 'undefined' ? cache.upgradeMaxChildren : cache.maxChildren,
    maxadults: typeof cache.upgradeMaxAdults !== 'undefined' ? cache.upgradeMaxAdults : cache.maxAdults,
    maxpets: typeof cache.upgradePets !== 'undefined' ? cache.upgradePets : maxPets,
    start: cache.date,
    end: cache.dateEnd,
    duration: cache.duration,
    code: productCode,
    comfort: comfortLevelName,
    housing: housingTypeName,
    offer: siteName,
    cottageName: housingProperty,
    guests: datas.nbPersons,
    actionCodeCode: datas.item.actionCode.code,
    actionCodeName: datas.item.actionCode.name,
    housingName: datas.item.housing.name,
    housingCode: datas.item.housing.code,
    priceOriginal: oPrice.original.value,
    priceOriginalRawBeforeTax: oPrice.original.rawBeforeTax,
    pricePromo: oPrice.promo.value,
    priceDiscount: oPrice.discount,
    taxTotal: oPrice.taxTotal,
    rawDifference: oPrice.rawDifference,
    pricePetsValueBeforeTax: oPrice.pets.valueBeforeTax,
    pricePetsRawBeforeTax: oPrice.pets.rawBeforeTax,
    photoDomainUrl: datas.item.photoOffer ? GLOBAL_SCRIPTS.BASELINK_MEDIA + datas.item.photoOffer['120x90'][0] : '',
    stock: cache.stock,
    destinationCode: datas.item.destination.code,
    countryName: datas.item.country.name,
    countryCode: datas.item.country.code,
    regionCode: datas.item.region.code,
    adultsNb: !SEARCH_SCRIPTS.PARTICIPANTS_MODIFIED ? 2 : (isParticipantObj && typeof participantsSelected.adult !== 'undefined' ? participantsSelected.adult.code : 0),
    childrenNb: !SEARCH_SCRIPTS.PARTICIPANTS_MODIFIED ? 0 : (isParticipantObj ? ( typeof participantsSelected.baby !== 'undefined' ? participantsSelected.baby.code : 0) + (typeof participantsSelected.child !== 'undefined' ? participantsSelected.child.code : 0) : 0),
    seniorsNb: !SEARCH_SCRIPTS.PARTICIPANTS_MODIFIED ? 0 : (isParticipantObj && typeof participantsSelected.senior !== 'undefined' ? participantsSelected.senior.code : 0),
    petsNb: !SEARCH_SCRIPTS.PARTICIPANTS_MODIFIED ? 0 : (isParticipantObj && typeof participantsSelected.pet !== 'undefined' ? participantsSelected.pet.code : 0),
    ages: typeof participantsSelected.ages !== 'undefined' ? JSON.stringify(participantsSelected.ages.map(age => {
      return age.code;
    })) : '[]',
    cottageToSelect: sessionStorage.getItem('basketDatas') !== null && JSON.parse(sessionStorage.getItem('basketDatas')).cottagesSelected[0].isFilled === true ? 2 : 1,
    sidebyside: sideBySide === 1,
    brandCode: brandCode
  };

  if (cache.bookingUpgrade && Object.keys(cache.bookingUpgrade).length) {
    dataAttributes.originalHousing = datas.item.housing.code;
    dataAttributes.originalHousingId = cache.bookingUpgrade.id;
    dataAttributes.originalHousingPrice = cache.priceCollapse;
    dataAttributes.upgradeCode = cache.bookingUpgrade.value;
  }

  if (isBookable) {
    if (!SEARCH_SCRIPTS.PARTICIPANTS_MODIFIED) {
      dataAttributes.src = '#js-popinParticipants';
      dataAttributes.type = 'inline';
      dataAttributes.tracking = `{"clickCode":"clickBoutonCheckoutParticipants${cp_postfix}","gaCategory":"${pageTemplate}${cp_postfix}","gaAction":"${hasMulticottage ? 'bouton checkout participants_multi cottage' : 'bouton checkout participants'}${cp_postfix}","gaLabel":"add","gaValue":1}`;
    } else {
      dataAttributes.tracking = `{"clickCode":"clickAccommodationBookingButton${cp_postfix}","gaCategory":"${pageTemplate}${cp_postfix}","gaAction":"${hasMulticottage ? 'bouton checkout participants_multi cottage' : 'bouton checkout participants'}${cp_postfix}","gaLabel":"add","gaValue":1,"accommodationCode": "${housingCode}"}`;
    }
    htmlBookButton = `
        <a
          title="${hasMulticottage ? wordings.addBasketLabel : wordings.book_now_label} ${housingProperty} ${siteName}"
          class="${hasMulticottage ? 'js-basketMulticottage' : !SEARCH_SCRIPTS.PARTICIPANTS_MODIFIED ? 'js-fancybox-popinParticipants' : 'js-goToEresa js-booking'}${hasMulticottage || SEARCH_SCRIPTS.PARTICIPANTS_MODIFIED ? ' js-buttonLoader' : ''} buttonContainer accCart-bookingButton js-Tracking--link${classIPLABEL}"`;

    for (const key in dataAttributes) {
      htmlBookButton += key === 'tracking' ? ` data-${key}='${dataAttributes[key]}'` : ` data-${key}="${dataAttributes[key]}"`;
    }

    htmlBookButton += `>
          <i class="button button--pinkWhite${hasMulticottage ? ' icon icon-shopcartarrow button--withIcon' : ''}">${hasMulticottage ? wordings.addBasketLabel : wordings.book_now_label}</i>
        </a>`;
  } else if (cache.availability) {
    htmlBookButton = `
      <div class="accCart-dispos">
        <span class="accCart-dispos--label">${wordings.housing_complete}</span>`;
    if (!hasMulticottage) {
      htmlBookButton += ` <span class="accCart-dispos--cta js-seeDispos"
      data-housing-code="${housingCode}"
      data-housing-type="${housing.housingTypeGrouping.name.replace('\'', '’')}"
      data-housing-label="${housingProperty.replace('\'', '’')}"
      data-product-code="${productCode}"
      data-housing-comfortlevelname="${comfortLevelName.replace('\'', '’')}"
      data-housing-typename="${housingTypeName.replace('\'', '’')}"
      data-product-name="${siteName.replace('\'', '’')}"
      data-housing-atname="${(typeof housing.specificName !== 'undefined' && housing.specificName.length ? housing.specificName + ', ' + housing.name : housingTypeName + ', ' + comfortLevelName).replace('\'', '’')}"
      data-housing-maxcapacity="${housing.capacity}"
      data-housing-maxbabies="${datas.item.cache.maxBabies}"
      data-housing-maxchildren="${datas.item.cache.maxChildren}"
      data-housing-maxadults="${datas.item.cache.maxAdults}"
      data-housing-maxpets="${maxPets}"`;
      for (const key in dataAttributes) {
        htmlBookButton += ` data-${key}="${dataAttributes[key]}"`;
      }
      htmlBookButton += `>
            ${wordings.housing_see_dispos}
          </span>`;
    }
    htmlBookButton += '</div>';
  }

  //gestion du cartouche MSG
  let htmlCartoucheMSG = '';
  let CartoucheMSGIcon = '';

  if (isBookable && typeof cartoucheMSG_article !== 'undefined' && cartoucheMSG_article.date && cache.date <= cartoucheMSG_article.date) {
    if (cartoucheMSG_article.iconMSG !== '') {
      CartoucheMSGIcon = `<img class="accCart-infoMessageIcon" src="${cartoucheMSG_article.iconMSG}" alt="Info Message Icon" />`;
    }

    htmlCartoucheMSG = `<div class="r-Grid-cell r-all--1o1 accCart-infoMessage">
      ${CartoucheMSGIcon}
      <p>${cartoucheMSG_article.texte_1}
        <a href="" class="js-fancybox-cartoucheMsg accCart-infoMessageLink" data-type="inline" data-src="#js-popinCartoucheMsg" title="${cartoucheMSG_article.titreLien}">${cartoucheMSG_article.texteLien}</a>
      </p>
    </div>`;
  }

  const slider = sliderPhotosTpl({
    productCode: productCode,
    housingCode: housing.code,
    brandCode: brandCode,
    resolutionToUse: {
      desktop: '566x250',
      tablet: '500x375',
      mobile: '566x250'
    },
    openPopinOnClick: {
      desktop: true,
      tablet: true,
      mobile: true
    },
    photosDatas: typeof photoList !== 'undefined' && photoList !== null ? photoList : {
      '500x375': [GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/500x375.jpg'],
      '566x250': [GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/566x250.jpg']
    },
    typeOfResult: 'housing',
    virtualTour: housing.virtualtour
  });

  const htmlListCoteaCoteList = `<li>${wordings_search.coteaCoteList.replaceAll('\n', '</li><li>')}</li>`;
  const coteACoteListOne = `
    <div class="accCart-cacContainer">
      <i class="icon icon-coteacote"></i>
      <span class="accCart-cacLabel">${wordings_search.optionCoteaCote}</span>
      <div class="genericTooltip tooltip-content">
        <i class="icon icon-coteacote"></i>
        <span class="accCart-cacLabel">${wordings_search.optionCoteaCote}</span>
        <ul>${htmlListCoteaCoteList}</ul>
      </div>
    </div>`;
  const coteACoteListTwo = `
    <div class="accCart-cacContainer green">
      <i class="icon icon-coteacote"></i>
      <span class="accCart-cacLabel">${wordings_search.coteaCoteDispo}</span>
      <div class="genericTooltip tooltip-content">
        <i class="icon icon-coteacote"></i>
        <span class="accCart-cacLabel">${wordings_search.optionCoteaCote}</span>
        <ul>${htmlListCoteaCoteList}</ul>
      </div>
    </div>`;
  const isSecondResult = sessionStorage.getItem('basketDatas') !== null;

  let htmlBlocUsps = '<ul class="accCart-Usps">';
  for (const item of usps) {
    if (item.teaser != '') {
      htmlBlocUsps += `<li>${item.teaser}</li>`;
    }
  }
  htmlBlocUsps += '</ul>';

  // CONCATENATION DE TOUT LE CONTENU
  return `
    <div class="accCart${modifier}${!isBookable ? ' is-full' : ''}" id="accCart_${housingCode}" data-priceCollapse="${cache.priceCollapse}">
      ${htmlDomainTitle}
      <div class="accCart-main r-Grid">
        <div class="r-Grid-cell r-all--1of1 r-minM--1of3 accCart-pictureContainer">
          ${slider}
          ${htmlNotesBlock}
        </div>
        <div class="accCart-informationContainer">
          <div class="accCart-TextAndPriceDuration">
            <div class="r-Grid-cell r-Grid r-all--1of1 r-minL--7of10 accCart-pictureAndText">
              <div class="r-Grid-cell r-all--1of1 r-minL--2of3 r-Grid accCart-textBlock">
                <div class="r-Grid-cell r-all--1of1 r-minM--1of1 accCart-mainInfos">
                  <div class=" accCart-title">
                    <h2 class="h4-like accCart-housingTitle">${housingProperty}</h2>
                    <div class="accCart-advantages accCart-advantages-icons r-Grid">
                      ${htmlBlocPMR}
                      ${htmlBlocPets}
                      ${htmlBlocWifi}
                    </div>
                  </div>
                  <ul class="accCart-specifications">
                    <li class="accCart-specificationsItem">
                      <i class="icon icon-couple"></i>
                      <span class="textIcon">${htmlCapacity}</span>
                    </li>
                    <li class="accCart-specificationsItem">
                      <i class="icon icon-bedroom"></i>
                      ${htmlBedroom}
                    </li>
                    <li class="accCart-specificationsItem">
                      <i class="icon icon-home"></i>
                      <span class="textIcon">${strArea}</span>
                    </li>
                  </ul>
                  ${hasMulticottage && !isSecondResult && sideBySide === 1 ? coteACoteListOne : ''}
                  ${hasMulticottage && isSecondResult && sideBySide === 1 ? coteACoteListTwo : ''}
                  ${GLOBAL_SCRIPTS.ABCTEST_ACCOS_BLOCK === 'C' && DEVICE.isMobile ? htmlBlocUsps : ''}
                  <div class="accCart-advantages u-Visible-desktop r-Grid">
                    ${htmlAdvantages}
                  </div>
                </div>
              </div>
            </div>
            <div class="r-Grid r-Grid-cell r-all--1of1 r-minL--3of10 accCart-priceDuration">
              <div class="r-Grid accCart-dateAndstockAlertContainer">
                <div class="accCart-dateAndstockAlert">
                  ${htmlBlocDates}
                  ${GLOBAL_SCRIPTS.ABCTEST_ACCOS_BLOCK === 'A' ? htmlStockAlert : ''}
                </div>
                <div class="accCart-priceAndText">
                  ${htmlBlocPrice}
                </div>
              </div>
              <div class="r-Grid-cell r-all--1o1 accCart-CTA${!isBookable ? ' is-full' : ''}">
                ${htmlLinkInfos}
                ${htmlBookButton}
              </div>
            </div>
          </div>
          ${GLOBAL_SCRIPTS.ABCTEST_ACCOS_BLOCK === 'A' ? htmlCartoucheMSG : ''}
        </div>
      </div>
    </div>`;
};

export { cartoucheHousing };